// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__XmUTO","wrapper":"Button_wrapper__z7vnu","arrow":"Button_arrow__Ya1ET","wrapped":"Button_wrapped__9GAgR","root":"Button_root__1zRQ_"};